// Read-along ("karaoke") helpers for the night player.
//
// The backend writes an alignment.json next to each tale's audio (built from
// the TTS character timings, spec §11.2):
//   {version, duration_sec, scenes: [{index, start, end}],
//    words: [{w, s, e, scene, ci}]}
// where `w` is the word text, `s`/`e` its start/end in seconds, `scene` the
// scene index and `ci` the character offset inside the scene's text.

// A word that closes a sentence: terminal punctuation optionally followed by
// closing quotes/brackets (e.g. `сказал.»`).
const SENTENCE_END = /[.!?…]["»”'’)\]]*$/;

// Group aligned words into display sentences. A sentence never crosses a scene
// boundary (the narration pauses there anyway), and each word keeps its global
// index so the player can key highlights.
export function buildSentences(words) {
    const sentences = [];
    let current = null;
    (words || []).forEach((word, index) => {
        if (current && current.scene !== word.scene) {
            sentences.push(current);
            current = null;
        }
        if (!current) {
            current = {scene: word.scene, start: word.s, end: word.e, words: []};
        }
        current.words.push({...word, index});
        current.end = word.e;
        if (SENTENCE_END.test(word.w)) {
            sentences.push(current);
            current = null;
        }
    });
    if (current) sentences.push(current);
    return sentences;
}

// Index of the last item whose start time is <= t, or -1 before the first.
// Items must be sorted by start time; `getStart` extracts it (words use `s`,
// sentences use `start`). Gaps between items keep the previous one active so
// the highlight never flickers off mid-pause.
export function lastStartedIndex(items, t, getStart) {
    let lo = 0;
    let hi = (items?.length || 0) - 1;
    let ans = -1;
    while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        if (getStart(items[mid]) <= t) {
            ans = mid;
            lo = mid + 1;
        } else {
            hi = mid - 1;
        }
    }
    return ans;
}

export function activeSentenceIndex(sentences, t) {
    return lastStartedIndex(sentences, t, s => s.start);
}

export function activeWordIndex(words, t) {
    return lastStartedIndex(words, t, w => w.s);
}
